import VerktoyOppgaveModalContainer from '@components/oppgave/verktoyoppgave-modal-container';
import { useAppDispatch } from '@store';
import { setStartAktivitet } from '@store/verktoy/slice/verktoySlice';

import type { Verktoy } from '@src/types/minhelseentities';

import Loader from '@helsenorge/designsystem-react/components/Loader';

import VerktoyDetailsPage from './verktoy-details-page';

interface VerktoyDetailsPageWrapperProps {
  verktoyLoading: boolean;
  verktoy: Verktoy | undefined;
}
export const VerktoyDetailsPageWrapper = ({ verktoyLoading, verktoy }: VerktoyDetailsPageWrapperProps): React.JSX.Element => {
  const dispatch = useAppDispatch();

  return (
    <>
      {verktoyLoading && <Loader />}
      {!verktoyLoading && verktoy && (
        <>
          <VerktoyDetailsPage
            verktoy={verktoy}
            {...(verktoy.Laeringsaktivitet && {
              startAktivitet: () => dispatch(setStartAktivitet({ aktivitetId: verktoy.Laeringsaktivitet!.LaeringsaktivitetId })),
            })}
          />
          {<VerktoyOppgaveModalContainer verktoy={verktoy} />}
        </>
      )}
    </>
  );
};
